// extracted by mini-css-extract-plugin
module.exports = {"doctor":"DoctorSection_doctor__Va2yD","markpen":"DoctorSection_markpen__3qq6p","image":"DoctorSection_image__9Ta_2"};